"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styles_1 = require("@mui/material/styles");
var Help_1 = __importDefault(require("@nerdwallet/react-icon/nerdwallet-ui/Help"));
var variables_1 = require("../../../styles/variables");
var TooltipButton = (0, styles_1.styled)("button")(function () { return ({
    cursor: "pointer",
    backgroundColor: "transparent",
    border: "1px solid transparent",
    display: "inline-block",
    height: "18px",
    padding: 0,
    position: "relative",
    width: "18px",
    "&:focus": {
        borderRadius: "4px",
    },
}); });
var TooltipTrigger = (0, react_1.forwardRef)(function (props, ref) {
    var _a;
    return (react_1.default.createElement(TooltipButton, { type: "button", ref: ref, "aria-label": props.arialLabel, sx: {
            width: "fit-content",
            border: "0",
        }, onClick: function (e) {
            e.preventDefault();
            props.onTriggerToggle();
        } }, (_a = props.children) !== null && _a !== void 0 ? _a : react_1.default.createElement(Help_1.default, { color: variables_1.colors["green-darkest"] })));
});
TooltipTrigger.displayName = "TooltipTrigger";
exports.default = TooltipTrigger;
